import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import DatePicker from "../../../components/DatePicker";
import DeliveryModal from "../../../components/Modal/DeliverymodalSearch";

import {
  deleteData,
  getAlert,
  getDataWithJoin,
  insertData,
  parseCurrency,
  updateData,
} from "../../../../utils/SamuiUtils";
import { useNavigate } from "react-router-dom";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataEmpPosition,
  dataEmpDept,
  dlLineList,
}) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [selectedDelivery, setSelectedDelivery] = useState(null);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleDeliveryShow = () => setShowDeliveryModal(true);
  const handleDeliveryClose = () => setShowDeliveryModal(false);

  const onRowSelectDL = (dl) => {
    setSelectedDelivery(dl);
    setFormData((prev) => ({
      ...prev,
      emp_delivery_id: dl.DL_Id,
      emp_delivery_name: dl.DL_LineName,
    }));
    handleDeliveryClose();
  };

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        emp_id: parseCurrency(window.localStorage.getItem("emp_id"), 10),
        emp_code: "",
        emp_prefix: "",
        emp_name: "",
        emp_dept: parseCurrency(formData.emp_dept, 10),
        emp_position: parseCurrency(formData.emp_position, 10),
        emp_position_detail: "",
        emp_startdate: moment().format("YYYY-MM-DD"), // วันที่ปัจจุบัน
        emp_tel: "",
        emp_status: "Y",
        emp_uuser: "",
        emp_ppass: "",
        emp_pin: "",
        gold_so: parseCurrency(formData.gold_so, 10),
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
        driver_flag: "",
        emp_delivery_id: null,
      };
      setFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        emp_id: parseCurrency(selectedData.Emp_Id, 10),
        emp_code: selectedData.Emp_Code,
        emp_prefix: selectedData.Emp_Prefix,
        emp_name: selectedData.Emp_Name,
        emp_dept: parseCurrency(selectedData.Emp_Dept, 10),
        emp_position: parseCurrency(selectedData.Emp_Position, 10),
        emp_position_detail: selectedData.Emp_Position_Detail,
        emp_startdate: selectedData.Emp_StartDate,
        emp_tel: selectedData.Emp_Tel,
        emp_status: selectedData.Emp_Status,
        emp_uuser: selectedData.Emp_UUser,
        emp_ppass: selectedData.Emp_PPass,
        emp_pin: selectedData.Emp_PIN,
        gold_so: parseCurrency(selectedData.Gold_SO, 10),
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
        driver_flag: selectedData.Driver_Flag,
        emp_delivery_id: selectedData.Emp_Delivery_Id || null,
        emp_delivery_name:
          formData?.emp_delivery_name ||
          (dlLineList && dlLineList.find((d) => d.DL_Id == selectedData.Emp_Delivery_Id)
            ? dlLineList.find((d) => d.DL_Id == selectedData.Emp_Delivery_Id).DL_LineName
            : null),
      };
      setFormData(initialData);

      if (selectedData.Emp_Delivery_Id && dlLineList) {
        const delivery = dlLineList.find(dl => dl.DL_Id === selectedData.Emp_Delivery_Id);
        if (delivery) {
          setSelectedDelivery(delivery);
        }
      }
    }
  }, [mode, setFormData, selectedData]);

  // If dlLineList loads after selectedData is set, auto-select the delivery
  useEffect(() => {
    const deliveryId = (selectedData && selectedData.Emp_Delivery_Id) || (formData && formData.emp_delivery_id);
    if (dlLineList && dlLineList.length > 0 && deliveryId) {
      const delivery = dlLineList.find((d) => d.DL_Id == deliveryId);
    
      if (delivery) {
        setSelectedDelivery(delivery);
        setFormData((prev) => ({
          ...prev,
          emp_delivery_id: delivery.DL_Id,
          emp_delivery_name: delivery.DL_LineName,
        }));
      }
    }
  }, [dlLineList, selectedData, setFormData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeDataEmpDept = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeDataEmpPosition = (e) => {
    const { name, value } = e.target;

    const selectedEmpPosition = dataEmpPosition?.find(
      (type) => type.PST_Id === parseCurrency(value, 10)
    );

    setFormData((prev) => ({
      ...prev,
      emp_position: value,
      emp_position_detail: selectedEmpPosition
        ? selectedEmpPosition.PST_Name
        : "",
    }));
  };

  const handleDateChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      emp_startdate: value ? value.format('YYYY-MM-DD') : null,
    }));
  };

  const handleInsertEmployee = async () => {
    try {
      const { emp_id, ...dataToInsert } = formData;

      const sanitizeData = (data) => {
        const sanitized = { ...data };
        sanitized.emp_dept =
          data.emp_dept === "" ? null : parseCurrency(data.emp_dept);
        sanitized.emp_position =
          data.emp_position === "" ? null : parseCurrency(data.emp_position);
        sanitized.gold_so = data.gold_so === "" ? 0 : parseCurrency(data.gold_so);
        sanitized.emp_tel = data.emp_tel === "" ? null : data.emp_tel;
        sanitized.emp_status = data.emp_status === "" ? "Y" : data.emp_status;
        sanitized.emp_startdate = data.emp_startdate === "" ? moment() : data.emp_startdate;
        return sanitized;
      };
      const sanitizedData = sanitizeData(dataToInsert);

      const fields = Object.keys(sanitizedData).join(", ");
      const values = Object.values(sanitizedData);

      const res = await insertData("Tb_Set_Employee", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting employee:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };
  const formatValues = (data) => {
    const { emp_id, ...rest } = data;
    return rest;
  };

  const handleUpdateEmployee = async () => {
    try {
      if (
        (!formData.emp_pin || formData.emp_pin === "-") &&
        (formData.driver_flag === "Y")
      ) {
        getAlert("WARNING", "โปรดกรอกข้อมูล PIN พนักงานด้วย");
        return;
      }

      // Use DB column-style keys for the update API (Emp_Id, Emp_Delivery_Id)
      const where = { Emp_Id: formData.emp_id };

      // Map UI form fields (camelCase) to DB column names (PascalCase)
      const values = {
        Emp_Code: formData.emp_code || null,
        Emp_Prefix: formData.emp_prefix || null,
        Emp_Name: formData.emp_name || null,
        Emp_Dept: formData.emp_dept || null,
        Emp_Position: formData.emp_position || null,
        Emp_Position_Detail: formData.emp_position_detail || null,
        Emp_StartDate: formData.emp_startdate || null,
        Emp_Tel: formData.emp_tel || null,
        Emp_Status: formData.emp_status || null,
        Emp_UUser: formData.emp_uuser || null,
        Emp_PPass: formData.emp_ppass || null,
        Emp_PIN: formData.emp_pin || null,
        Gold_SO: formData.gold_so || null,
        Comp_Id: formData.comp_id || parseCurrency(window.localStorage.getItem("company")),
        Driver_Flag: formData.driver_flag || null,
      };

      if (formData.emp_delivery_id !== undefined && formData.emp_delivery_id !== null) {
        values.Emp_Delivery_Id = formData.emp_delivery_id;
      }

      // Remove undefined keys
      Object.keys(values).forEach((k) => {
        if (values[k] === undefined) values[k] = null;
      });

      const res = await updateData("Tb_Set_Employee", values, where);
 
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize(selectedData?.Emp_Id);
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const checkEmCode = async () => {
    const { item_id, ...dataToInsert } = formData;
    const resItemCode = await getDataWithJoin(
      `a.*`,
      `[dbo].[Tb_Set_Employee] AS a`,
      `WHERE a.Emp_Code = '${formData.emp_code}'`, ""
    );

    if (resItemCode && resItemCode.length > 0) {
      getAlert("FAILED", "มีรหัสพนักงานแล้ว");
      setFormData((prev) => ({ ...prev, emp_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสพนักงานนี้สามารถใช้ได้");
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Employee",
            `WHERE Emp_Id = ${selectedData.Emp_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const confirmAndUpdate = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการแก้ไขข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleUpdateEmployee();
          // await callInitialize();
          // window.location.href = "/employee";
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (
        !formData.emp_code ||
        !formData.emp_dept ||
        !formData.emp_name ||
        !formData.emp_position ||
        !formData.emp_position_detail
      ) {
        getAlert("WARNING", "โปรดกรอกข้อมูลให้ครบถ้วน");
        return;
      }

      if (
        (!formData.emp_pin || formData.emp_pin === "-") &&
        (formData.driver_flag === "Y")
      ) {
        getAlert("WARNING", "โปรดกรอกข้อมูล PIN พนักงานด้วย");
        return;
      }

      if (mode === "I") {
        await handleInsertEmployee();
      } else if (mode === "U") {
        await handleUpdateEmployee();
      }
      setFormData({
        emp_id: "", // Int
        emp_code: "",
        emp_prefix: "",
        emp_name: "",
        emp_dept: "",
        emp_position: "",
        emp_position_detail: "",
        emp_startdate: "",
        emp_tel: "",
        emp_status: "Y",
        emp_uuser: "",
        emp_ppass: "",
        emp_pin: "",
        gold_so: "",
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
        driver_flag: "",
        emp_delivery_id: null,
      });
      setSelectedDelivery(null);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <div>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/employee" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลพนักงาน</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>รหัสพนักงาน</label>
                <input type="text" className="form-control" name="emp_code" value={formData.emp_code || ""} onBlur={checkEmCode} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>คำนำหน้า</label>
                <input type="text" className="form-control" name="emp_prefix" value={formData.emp_prefix || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ชื่อ</label>
                <input type="text" className="form-control" name="emp_name" value={formData.emp_name || ""} onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label>แผนก</label>
                <div className="input-group">
                  <select className="form-select" name="emp_dept" value={formData.emp_dept} onChange={handleChangeDataEmpDept} disabled={dataEmpDept.length <= 0}>
                    {dataEmpDept.map((type, index) => (
                      <option key={index} value={type.Dept_Id}>{type.Dept_Name}</option>
                    ))}
                  </select>
                  {dataEmpDept.length <= 0 && (
                    <button onClick={() => navigate("/dept")} className="btn btn-warning text-white" type="button">+</button>
                  )}
                </div>
              </div>

              <div className="col-md-4">
                <label>ตำแหน่ง</label>
                <div className="input-group">
                  <select className="form-select" name="emp_position" value={formData.emp_position || ""} onChange={handleChangeDataEmpPosition} disabled={dataEmpPosition.length <= 0}>
                    {dataEmpPosition.map((type, index) => (
                      <option key={index} value={type.PST_Id}>{type.PST_Name}</option>
                    ))}
                  </select>
                  {dataEmpPosition.length <= 0 && (
                    <button onClick={() => navigate("/position")} className="btn btn-warning text-white" type="button">+</button>
                  )}
                </div>
              </div>

              <div className="col-md-4">
                <label>รายละเอียดตำแหน่ง</label>
                <input type="text" className="form-control" name="emp_position_detail" value={formData.emp_position_detail || ""} onChange={handleChange} />
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">การติดต่อและเริ่มงาน</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label>เบอร์โทร</label>
                <input type="text" className="form-control" name="emp_tel" value={formData.emp_tel || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>วันที่เริ่มงาน</label>
                <DatePicker
                  label=""
                  name=""
                  value={formData.emp_startdate}
                  onChange={(date) => handleDateChange(date)}
                  disabled={false}
                />
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">บัญชีผู้ใช้งาน</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label>บัญชีผู้ใช้</label>
                <input type="text" className="form-control" name="emp_uuser" value={formData.emp_uuser || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>รหัสผ่าน</label>
                <div className="input-group">
                  <input type={showPassword ? "text" : "password"} className="form-control" name="emp_ppass" value={formData.emp_ppass || ""} onChange={handleChange} />
                  <button type="button" className="btn btn-warning text-white" onClick={toggleShowPassword}>
                    <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"} />
                  </button>
                </div>
              </div>
              <div className="col-md-6">
                <label>Pin พนักงาน</label>
                <input type="text" className="form-control" name="emp_pin" value={formData.emp_pin || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>สถานะ</label>
                <select className="form-select" name="emp_status" value={formData.emp_status || "Y"} onChange={handleChange}>
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
              <div className="col-md-6">
                <label>สิทธิ์การเข้าถึง Vansale</label>
                <select className="form-select" name="driver_flag" value={formData.driver_flag} onChange={handleChange}>
                  <option value="">กรุณาเลือกสิทธิ์</option>
                  <option value="Y">คนขับรถ</option>
                  <option value="A">แอดมิน</option>
                </select>
              </div>
              {localStorage.getItem("company") === "2" && (
                <div className="col-md-6">
                  <label>สายส่ง</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={
                        selectedDelivery
                          ? selectedDelivery.DL_LineName
                          : formData.emp_delivery_name || ""
                      }
                      readOnly
                      placeholder="เลือกสายส่ง"
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={handleDeliveryShow}
                      disabled={!dlLineList || dlLineList.length === 0}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              )}
            </div>

            {localStorage.getItem("company") === "2" && (
              <DeliveryModal
                showSoModal={showDeliveryModal}
                handleSoClose={handleDeliveryClose}
                dlLineList={dlLineList || []}
                onRowSelectDL={onRowSelectDL}
              />
            )}

            <div className="row mt-4">
              {mode !== "I" ? (
                <div className="d-flex justify-content-between align-items-center">
                  <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                  <div className="d-flex gap-2">
                    <button onClick={() => (window.location.href = "/employee")} type="button" className="btn btn-dark btn-lg">ยกเลิก</button>
                    <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก</button>
                  </div>
                </div>
              ) : (
                <div className="d-flex">
                  <FormAction onSubmit={handleSubmit} onUpdate={handleSubmit} onDelete={handleDelete} mode={mode} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
